/* eslint-disable no-undef */
import React from 'react';
import _ from 'lodash';
import ProductCartForm from 'shared/components/ProductCart';

const getRow = (parameters) => {
  if (!parameters) return null;

  const n = _.parseInt(parameters.row_selected);
  return _.isInteger(n) ? n : null;
};

const getColumn = (parameters) => {
  if (!parameters) return null;

  const n = _.parseInt(parameters.column_selected);
  return _.isInteger(n) ? n : null;
};

const computeDiscount = (quantity, unitPrice) => {
  let discount = 0;
  const isFirstOrder =
    typeof had_previous_order_fixture === 'undefined'
      ? true
      // eslint-disable-next-line no-undef
      : !had_previous_order_fixture;
  if (isFirstOrder && quantity > 0) {
    discount = unitPrice * 0.25;
  }

  if (quantity === 1) return discount;

  let percent = 0;
  if (quantity <= 5) {
    percent = 5;
  } else if (quantity <= 10) {
    percent = 7.5;
  } else {
    percent = 10;
  }

  discount +=
    unitPrice * (isFirstOrder ? quantity - 1 : quantity) * (percent / 100.0);
  return _.round(discount, 2);
};

const Cart = (props) => {
  const {
    quantity,
    parameters,
    quote,
    onAddToCart,
    onChangeQuantity,
    addingToCart,
  } = props;

  let unitPrice;
  let totalPrice;
  let discountLabel;
  let discountValue;
  let discountSubtotal = '';

  const leadTime = parameters ? parameters.lead_time : '';
  const row = getRow(parameters);
  const col = getColumn(parameters);
  const pricing = _.get(quote, 'line_items[0].pricing');

  if (pricing && row !== null && col !== null) {
    if (pricing[row] && pricing[row][col]) {
      unitPrice = parseFloat(pricing[row][col]);
      unitPrice = parseFloat(accounting.toFixed(unitPrice, 2));

      totalPrice = unitPrice * parseFloat(quantity);
      discountLabel = 'Discount';
      const discount = computeDiscount(parseFloat(quantity), unitPrice);

      unitPrice = accounting.formatMoney(unitPrice);
      discountSubtotal = accounting.formatMoney(totalPrice);
      discountValue = accounting.formatMoney(discount);
      totalPrice = accounting.formatMoney(totalPrice - discount);
    }
  }

  const properties = [
    {
      label: 'QTY:',
      value: (
        <input
          type="number"
          name="quantity"
          onChange={(e) => onChangeQuantity(e.target.value)}
          value={quantity}
          className="form-control product-qty"
          min="1" />
      ),
    },
    { label: 'Lead Time:', value: leadTime },
  ];

  return (
    <div>
      <ProductCartForm
        properties={properties}
        unitPrice={unitPrice}
        totalPrice={totalPrice}
        discountLabel={discountLabel}
        discountValue={discountValue}
        discountSubtotal={discountSubtotal}
        discountAlwaysShow
        onAddToCart={onAddToCart}
        addingToCart={addingToCart} />
    </div>
  );
};

export default Cart;
